import { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";

import Landing from "@/pages/public/Landing";
import Submit from "@/pages/public/Submit";
import About from "@/pages/public/About";

const AdminApp = lazy(() => import("@/pages/admin/AdminApp"));

function Fallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream">
      <div className="font-display text-sylhet-forest animate-pulse text-lg">Loading…</div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Suspense fallback={<Fallback />}>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/submit" element={<Submit />} />
              <Route path="/about" element={<About />} />
              <Route path="/admin/*" element={<AdminApp />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
